import { jsx } from "react/jsx-runtime";
import { useRef, useMemo, createContext, useContext } from "react";
const ScrollContext = createContext(void 0);
const ScrollProvider = ({ children }) => {
  const scrollViewRef = useRef(null);
  const value = useMemo(
    () => ({
      scrollTo: (element) => {
        if (element && scrollViewRef.current) {
          const { top } = element.getBoundingClientRect();
          if (top < 0 || top > window.innerHeight) {
            const headerHeight = getSiteHeaderHeight(scrollViewRef.current);
            const wixAdHeight = getWixAdHeight();
            const newTop = top + window.scrollY - 20 - headerHeight - wixAdHeight;
            window.scrollTo({
              top: newTop,
              behavior: "smooth"
            });
          }
        }
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx("div", { ref: scrollViewRef, children: /* @__PURE__ */ jsx(ScrollContext.Provider, { value, children }) });
};
function useScroll() {
  const context = useContext(ScrollContext);
  if (context === void 0) {
    throw new Error("useScroll must be used within a ScrollProvider");
  }
  return context;
}
function getSiteHeaderHeight(formElement) {
  const classicHeader = document.querySelector("#SITE_HEADER");
  const potentialHeader = formElement.closest("main")?.previousElementSibling;
  const studioHeader = potentialHeader?.tagName === "HEADER" ? potentialHeader : void 0;
  const header = classicHeader || studioHeader;
  const headerPosition = header && window.getComputedStyle(header).position;
  return header && (headerPosition === "sticky" || headerPosition === "fixed") ? header.getBoundingClientRect().height : 0;
}
function getWixAdHeight() {
  const ad = document.querySelector("#WIX_ADS");
  return ad && window.getComputedStyle(ad).position === "fixed" ? ad.getBoundingClientRect().height : 0;
}
export {
  ScrollProvider,
  getSiteHeaderHeight,
  getWixAdHeight,
  useScroll
};
//# sourceMappingURL=scroll-provider.js.map
